export default function getScaleBandwidth(scale) {
  // Broaden type before using 'xxx' in s as typeguard.
  const s = scale;
  return s && 'bandwidth' in s ? s?.bandwidth() ?? 0 : 0;
}